import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { Flex, Box } from 'rebass'
import typography from '../../utils/typography'
import { ImageNavLink, NavLink } from '../../utils/style'

import IconClose from '../../vectors/IconClose'
import IconMagnifyingGlass from '../../vectors/IconMagnifyingGlass'
import HeaderLogo from '../HeaderLogo'
import HeaderOmniSearch from '../HeaderOmniSearch'
import EVENTS from '../../utils/events'

/*************************
 STYLES: Section Link & Close
 **************************/
const PrimaryNavLink = styled(NavLink)`
  height: ${typography.rhythm(1.3)};
  -webkit-tap-highlight-color: ${(props) => props.theme.colors.grey_light_op30};
  ${ImageNavLink}
`

const IconCloseClear = styled.a`
  cursor: pointer;
  position: absolute;
  top: ${(props) => (props.minimal ? rem(18) : rem(6))};
  right: ${(props) => (props.minimal ? rem(25) : rem(15))};
  width: ${rem(17)};
  z-index: 1000;
  background: white;
  svg {
    width: ${rem(14)};
  }
  path {
    transition: fill 0.5s cubic-bezier(0.19, 1, 0.22, 1);
  }
  &:hover path {
    fill: rgba(66, 76, 94, 1);
  }
`

/*************************
 STYLES: Contact
 **************************/
const SearchFlex = styled(Flex)`
  width: 100vw;
  z-index: 1000;
  position: absolute;
  top: 0;
`

const SearchBox = styled(Box)``

class HeaderContractedOmniSearchModal extends React.PureComponent {
  constructor() {
    super()
    this.state = { hidden: true }
    this._hide = this._hide.bind(this)
    this._show = this._show.bind(this)
    this._reverse = this._reverse.bind(this)
  }

  _hide() {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event(EVENTS.CONTENT.DIMMER_OFF))
    }
    this.setState({ hidden: true })
  }

  _show() {
    this.setState({ hidden: false })
  }

  _reverse() {
    this.state.hidden ? this._show() : this._hide()
  }

  render() {
    const modal = this.state.hidden ? null : (
      <SearchFlex minimal={this.props.minimal}>
        <Box width={this.props.wide ? [2 / 12] : [4 / 12]}>
          <HeaderLogo location="/" compact={!this.props.minimal} />
        </Box>
        <SearchBox width={this.props.wide ? [10 / 12] : [8 / 12]}>
          <HeaderOmniSearch minimal />
          <IconCloseClear
            minimal={this.props.minimal}
            href={'javascript:void(0)'}
            onClick={this._reverse}
          >
            <IconClose />
          </IconCloseClear>
        </SearchBox>
      </SearchFlex>
    )

    return (
      <>
        <PrimaryNavLink
          href={'javascript:void(0)'}
          onClick={this._reverse}
          aria-label="Search"
        >
          <IconMagnifyingGlass />
        </PrimaryNavLink>
        {modal}
      </>
    )
  }
}

export default HeaderContractedOmniSearchModal
